import type { Card } from '../../../types';

const SUIT_GLYPH: Record<string, string> = { S: '♠', H: '♥', D: '♦', C: '♣' };

function CardFace({ card }: { card: Card }) {
  const red = card.suit === 'H' || card.suit === 'D';
  return (
    <div
      className={`flex h-20 w-14 flex-col items-center justify-center rounded-lg border bg-white text-lg font-bold shadow ${
        red ? 'text-rose-600' : 'text-slate-900'
      }`}
    >
      <span>{card.rank}</span>
      <span>{SUIT_GLYPH[card.suit] ?? '?'}</span>
    </div>
  );
}

function HiddenCard() {
  return (
    <div className="flex h-20 w-14 items-center justify-center rounded-lg border border-gold bg-felt-dark text-2xl text-gold shadow">
      ?
    </div>
  );
}

export function HandDisplay({
  title,
  cards,
  total,
  hideHole = false,
  highlight = false,
  badge,
}: {
  title: string;
  cards: Card[];
  total: number | null;
  hideHole?: boolean;
  highlight?: boolean;
  badge?: string;
}) {
  return (
    <div
      className={`rounded-xl p-4 ${highlight ? 'bg-white/5 ring-2 ring-gold' : ''}`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span className="text-sm font-semibold text-slate-300">{title}</span>
        {total !== null && (
          <span className="rounded-full bg-felt-dark px-2 py-0.5 text-xs text-gold">
            {total}
          </span>
        )}
        {badge && (
          <span className="rounded-full bg-gold px-2 py-0.5 text-xs font-bold text-felt-dark">
            {badge}
          </span>
        )}
      </div>
      <div className="flex gap-2">
        {cards.map((c, i) =>
          hideHole && i === 1 ? <HiddenCard key={i} /> : <CardFace key={i} card={c} />,
        )}
      </div>
    </div>
  );
}
